import { render, staticRenderFns } from "./actBanner.vue?vue&type=template&id=183d4d97&scoped=true&"
import script from "./actBanner.vue?vue&type=script&lang=js&"
export * from "./actBanner.vue?vue&type=script&lang=js&"
import style0 from "./actBanner.vue?vue&type=style&index=0&id=183d4d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d4d97",
  null
  
)

export default component.exports